import Root from "./layouts/Root.tsx";
import { Routes, Route } from "react-router";
import ScheduleEntry from "./components/SheduleEntry.tsx";
import Stub from "./components/Stub.tsx";
import MonthSchedule from "./layouts/MonthSchedule.tsx";

export default function App() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register("/service-worker.js");
  }
  return (
    <Routes>
      <Route index element={<Root />} />
      <Route path="/schedule" element={<Root />}>
        <Route path=":id" element={<Stub />} />
        <Route path="first" element={<MonthSchedule>kek</MonthSchedule>} />
        <Route path="second" element={<ScheduleEntry />} />
      </Route>
    </Routes>
  );
}
